module.exports = __webpack_public_path__ + "static/media/no.7f986039.svg";